// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__RL3Ab","legacyBtn":"MutateMid_legacyBtn__25EqG"};